export const msalConfig = {
  auth: {
    clientId: window.__RUNTIME_CONFIG__?.VITE_AAD_APP_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${window.__RUNTIME_CONFIG__?.VITE_AAD_APP_TENANT_ID}`,
    redirectUri: window.__RUNTIME_CONFIG__?.VITE_URI,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [window.__RUNTIME_CONFIG__?.VITE_AAD_APP_SCOPE ?? "User.Read"],
};
